/**
 * お問い合わせフォーム プログレッシブ・エンハンスメント
 *
 * - JS 無効/失敗時は native POST にフォールバック（form は action=/api/contact method=post のまま動く）
 * - 送信を横取りし fetch(POST, Accept: application/json) で送信
 * - 送信中はボタン disabled + aria-busy + 「送信中…」で二重送信防止
 * - 成功で /contact/thanks/ へ遷移、失敗はインラインでエラー表示
 */
document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("contact-form") as HTMLFormElement | null;
  if (!form) return;

  const errorBanner = document.getElementById("contact-error");
  const submitButton = form.querySelector<HTMLButtonElement>('button[type="submit"]');
  const submitLabel = submitButton ? submitButton.textContent : "";

  const fieldNames = ["name", "company", "email", "type", "message", "agree"];

  const clearErrors = (): void => {
    if (errorBanner) {
      errorBanner.textContent = "";
      errorBanner.hidden = true;
    }
    fieldNames.forEach((fieldName) => {
      const input = form.elements.namedItem(fieldName) as HTMLElement | null;
      if (input) {
        input.classList.remove("is-error");
        input.removeAttribute("aria-invalid");
      }
    });
  };

  const showBanner = (msg: string): void => {
    if (!errorBanner) return;
    errorBanner.textContent = msg;
    errorBanner.hidden = false;
  };

  const ERROR_MESSAGES: Record<string, string> = {
    validation: "入力内容をご確認ください。",
    turnstile: "セキュリティチェックに失敗しました。もう一度お試しください。",
    bad_request: "送信内容が正しくありません。もう一度お試しください。",
    server_error: "送信に失敗しました。お手数ですが時間をおいて再度お試しください。",
  };

  // 非JS往復後（?error=）の保険バナー
  const params = new URLSearchParams(window.location.search);
  const errorParam = params.get("error");
  if (errorParam) {
    showBanner(ERROR_MESSAGES[errorParam] || ERROR_MESSAGES.server_error);
  }

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    clearErrors();

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.setAttribute("aria-busy", "true");
      submitButton.textContent = "送信中…";
    }

    const restoreButton = (): void => {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.removeAttribute("aria-busy");
        submitButton.textContent = submitLabel;
      }
    };

    fetch(form.action, {
      method: "POST",
      body: new FormData(form),
      headers: { Accept: "application/json" },
    })
      .then(async (res) => {
        const json = (await res.json().catch(() => null)) as {
          ok?: boolean;
          redirect?: string;
          error?: string;
          fields?: Record<string, string>;
        } | null;

        if (res.ok && json && json.ok) {
          window.location.assign(json.redirect || "/contact/thanks/");
          return;
        }

        restoreButton();

        if (json && json.fields) {
          let firstErrorInput: HTMLElement | null = null;
          Object.keys(json.fields).forEach((fieldName) => {
            const input = form.elements.namedItem(fieldName) as HTMLElement | null;
            if (input) {
              input.classList.add("is-error");
              input.setAttribute("aria-invalid", "true");
              if (!firstErrorInput) firstErrorInput = input;
            }
          });
          showBanner(ERROR_MESSAGES.validation);
          if (firstErrorInput) {
            (firstErrorInput as HTMLElement).focus();
          }
        } else {
          const code = (json && json.error) || "server_error";
          showBanner(ERROR_MESSAGES[code] || ERROR_MESSAGES.server_error);
        }
      })
      .catch(() => {
        // fetch 自体が失敗したら native POST にフォールバック
        restoreButton();
        form.submit();
      });
  });
});
